<template>
    <div>
        <div class="action-header">
            <div class="search-container">
                <div class="search-input">
                    <v-text-field
                        v-model="search"
                        prepend-inner-icon="search"
                        :placeholder="this.$vuetify.lang.t('$vuetify.bureau.searchText')"
                        solo
                        height="40px"
                        @keyup.enter="searchBureaus()">
                    </v-text-field>
                </div>

                <div class="ml-3">
                    <v-btn
                        height="40px"
                        color="primary"
                        outlined
                        @click="searchBureaus()">
                        {{ $vuetify.lang.t('$vuetify.bureau.search') }}
                    </v-btn>
                </div>
            </div>
        </div>
        <v-card class="content-container">
            <v-data-table
                :footer-props="{
                    'items-per-page-options': [10, 20, 30, 50, 100]
                }"
                @page-count="pageCount = $event"
                :page.sync="page"
                :headers="headers"
                :options.sync="options"
                :server-items-length="totalBureau"
                :items="bureaus"
                :loading="loading">
            </v-data-table>
        </v-card>
        <div class="pt-2 paginator-box">
            <div>
                <v-pagination v-model="page" :length="pageCount"></v-pagination>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Bureau',

    data () {
        return {
            search: '',
            pageCount: 1,
            page: 1,
            options: {},
            loading: false,
            totalBureau: 0,
            bureaus: []
        }
    },

    computed: {
        headers () {
            return [
                { text: this.$vuetify.lang.t('$vuetify.bureau.orgId'), value: 'organization_id', width: '20%' },
                { text: this.$vuetify.lang.t('$vuetify.bureau.bureau'), value: 'name', width: '22%' },
                { text: this.$vuetify.lang.t('$vuetify.bureau.bureauAcronym'), value: 'short_name', width: '18%' },
                { text: this.$vuetify.lang.t('$vuetify.bureau.parentId'), value: 'parent_id', width: '15%' },
                { text: this.$vuetify.lang.t('$vuetify.bureau.organization'), value: 'parent_name', width: '15%' },
                { text: this.$vuetify.lang.t('$vuetify.bureau.totalEmployee'), value: 'total_employee', width: '10%' }
            ]
        }
    },

    methods: {
        async searchBureaus () {
            this.options.page = 1
            await this.getBureaus()
        },

        async getBureaus () {
            this.loading = true
            const { sortBy, sortDesc, page, itemsPerPage } = this.options

            let url = `bureaus?page=${page}&itemsPerPage=${itemsPerPage}`

            if (sortBy[0]) {
                url += `&sortBy=${sortBy[0]}`
            }

            if (sortDesc[0]) {
                url += `&sortDesc=${sortDesc[0]}`
            }

            if (this.search) {
                url += `&search=${this.search}`
            }

            const res = await this.axios.get(url)
            if (res && res.data && res.data.status === 'ok') {
                this.bureaus = res.data.data
                this.totalBureau = res.data.total
                this.loading = false
            }
        }
    },

    watch: {
        options: {
            async handler () {
                await this.getBureaus()
            },
            deep: true
        },

        '$vuetify.lang.current': {
            handler: async function (after, before) {
                await this.getBureaus()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.search-container {
    ::v-deep .v-input__control > .v-input__slot {
        min-height: auto !important;
        display: flex !important;
        align-items: center !important;
        box-shadow: none !important;
        border: 1px solid #a8a8a8 !important;
        width: 280px;
    }
}
</style>
